import modelStore from "./model";
import modelConfigStore from "./model-config";
import registerStore from "./register";

export default {
  data() {
    return {
      pageLoading: false,
    };
  },
  mixins: [modelStore, modelConfigStore, registerStore],
};
